import React, {memo, useContext, useEffect, useMemo, useState} from 'react';
import {Alert} from "react-bootstrap";
import {wsUrl} from "../../constants";
import {UserContext} from "../../context";
import OpenCheckboxShift from "./OpenCheckboxShift";
import CheckboxShiftBalance from "./CheckboxShiftBalance";
import ServiceReceipt from "./ServiceReceipt";
import ServiceOutgoingModal from '../CloseRegisterModal';
import ErrorModalWindow from '../ErrorModalWindow';
import Loader from "../Loader";

const CheckboxShift = () => {
  const [shift, setShift] = useState(null);
  const [receipt, setReceipt] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showServiceOutgoingModal, setShowServiceOutgoingModal] = useState(false);

  const user = useContext(UserContext);

  useEffect(() => {
    getShift();
  }, []);

  useEffect(() => {
    if (shift && shift.status === 'CREATED') {
      setTimeout(getShift, 1000);
    }
  }, [shift]);

  const openShift = (initialBalance) => processShift({
    method: 'open_shift',
    initial_balance: initialBalance,
  });

  const getShift = () => processShift({method: 'get_shift'});

  const serviceOutgoing = (balance) => {
    setShowServiceOutgoingModal(false);
    processShift({method: 'service_outgoing', value: balance});
  }

  const closeShift = () => {
    if (window.confirm('Ви дійсно бажаєте закрити зміну?')) {
      processShift({method: 'close_shift'});
    }
  };

  const processShift = (payload = {}) => {
    const ws = new WebSocket(`${wsUrl}/checkbox_shift`);

    ws.onopen = () => {
      setIsLoading(true);
      ws.send(JSON.stringify({
        ...payload,
        cash_desk: localStorage.getItem('каса'),
        user_id: user.id,
        token: window.sessionStorage.getItem('token'),
      }));
    };

    ws.onerror = () => {
      setIsLoading(false);
      setError('Помилка роботи запиту.');
    }

    ws.onmessage = async function (evt) {
      const message = JSON.parse(evt.data);
      if (message.error) {
        setError(message.error);
      } else if (message.result) {
        console.log(message.result);
        if (message.result.receipt) {
          await setReceipt(message.result.receipt);
          window.print();
          await setReceipt(null);
        }
        message.result.shift && await setShift(message.result.shift);
      }
      ws.close(1000, 'OK');
      setIsLoading(false);
    };
  }

  const status = useMemo(() => {
    if (!shift) return 'Завантаження...';
    if (!shift.status) return 'Не відкрито';
    if (shift.status === 'CREATED') return 'Зміна створена, очікує відкриття';
    if (shift.status === 'OPENED') return 'Зміна відкрита';
    if (shift.status === 'CLOSED') return 'Зміна закрита';
    return `Невідомий статус: ${shift.status}`;
  }, [shift]);

  return (
    <>
      <ServiceOutgoingModal
        show={showServiceOutgoingModal}
        onHide={() => setShowServiceOutgoingModal(false)}
        onCloseRegisterFormConfirm={serviceOutgoing}
      />
      <ServiceReceipt
        show={!!receipt}
        onHide={() => setReceipt(null)}
        receipt={receipt}
      />
      {error && (
        <ErrorModalWindow
          text={error}
          show={!!error}
          onHide={() => setError(null)}
        />
      )}
      <Alert variant='primary'>
        <div><b>Зміна "Дінософія"</b></div>
        Статус: <b>{status}</b>
        {shift && !shift.id && <OpenCheckboxShift onOpenShift={openShift}/>}
        {shift && shift.id && shift.status === 'OPENED' && (
          <CheckboxShiftBalance
            balance={shift.balance}
            onRefreshBalance={getShift}
            onCloseShift={closeShift}
            onServiceOutgoing={() => setShowServiceOutgoingModal(true)}
          />
        )}
        {isLoading && <Loader minHeight={16} /> }
      </Alert>
    </>
  )
}

export default memo(CheckboxShift, () => true);
